var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    fill: "none",
    height: 28,
    role: "img",
    viewBox: "0 0 24 28",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5008 0.504822L23.5109 5.57685C23.83 5.9007 24.0062 6.34043 23.9998 6.79604C23.9601 9.73131 23.0823 20.7898 12.4747 27.1905C12.1826 27.3667 11.8174 27.3667 11.5253 27.1905C0.917735 20.7898 0.0398531 9.73131 0.00016586 6.79604C-0.0061841 6.34043 0.170027 5.9007 0.489113 5.57685L5.49923 0.504822C5.81832 0.180974 6.25329 0 6.70731 0H17.2927C17.7467 0 18.1817 0.182561 18.5008 0.504822ZM8.37258 10.6552C8.37258 14.3762 10.4617 16.4463 12.8445 16.4463L12.843 16.4479C14.7781 16.4479 15.9862 15.2335 16.5989 14.0714C16.6212 14.0302 16.6561 14 16.699 13.9841C16.7418 13.9683 16.7879 13.9683 16.8307 13.9857L17.3451 14.1921C17.3863 14.2096 17.4213 14.2397 17.4419 14.281C17.4625 14.3207 17.4673 14.3667 17.4562 14.4112C16.8688 16.5178 15.1623 18.6117 12.3127 18.6117C8.86788 18.6117 5.91673 16.0256 5.91673 12.2887C5.91673 8.55174 8.4456 5.52598 12.1476 5.52598C15.3369 5.52598 17.2244 7.46748 17.2244 8.97084C17.2244 9.55503 16.8403 9.95825 16.1989 9.95825C15.4666 9.95825 15.08 9.29096 14.6425 8.53605C14.0729 7.55297 13.4172 6.42133 11.8 6.42133C9.98547 6.42133 8.37258 8.27234 8.37258 10.6552Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShield);
export default __webpack_public_path__ + "static/media/logo-shield.60f956904b94d5686e182901a2548a97.svg";
export { ForwardRef as ReactComponent };